class CategoryMenu extends HTMLElement {
  constructor() {
    super();

    this.itemsToShow = this.dataset.itemsToShow;
    this.buttonMore = this.querySelector('.category-menu__item-button');
    this.layout = this.dataset.layout;
    if (this.buttonMore) {
      this.strings = {
        showText: this.buttonMore.dataset.show,
        hideText: this.buttonMore.dataset.hide
      };
      this.buttonMoreText = this.buttonMore.querySelector('span');

      this.buttonMore.addEventListener('click', this.onClick.bind(this));
    }

    this.initPages();
  }

  initPages() {
    if (this.layout === 'fixed') {
      document.body.classList.add('cmbody-fixed');
      const body = this.querySelector('.category-menu__body');
      if (body) {
        body.addEventListener('mouseenter', () => {
          this.classList.add('hover');
        });

        body.addEventListener('mouseleave', () => {
          this.classList.remove('hover');
        });
      }
    }
  }

  onClick(e) {
    this.buttonMore.classList.toggle('active');
    const isActive = this.buttonMore.classList.contains('active');

    this.querySelectorAll('.active-status').forEach((item) => {
      if (isActive) {
        item.classList.add('show');
        this.buttonMoreText.innerText = this.strings.hideText;
      } else {
        item.classList.remove('show');
        this.buttonMoreText.innerText = this.strings.showText;
      }
    });
  }
}

customElements.define('category-menu', CategoryMenu);

document.addEventListener("DOMContentLoaded", (event) => {
  const categoryMenu = document.querySelector('category-menu');
  const headerSticky = document.querySelector('sticky-header');
  const layout = categoryMenu.dataset.layout;
  if (categoryMenu && headerSticky && layout !== 'fixed') {
    headerSticky.appendChild(categoryMenu);
    const headerStickyPosition = headerSticky.getBoundingClientRect();
    const categoryMenuHeader = categoryMenu.querySelector('.category-menu__header');
    if (categoryMenuHeader) {
      const categoryMenuHeaderPosition = categoryMenuHeader.getBoundingClientRect();
      categoryMenu.style.setProperty('--max-content-height', `calc(100vh - ${headerStickyPosition.height + headerStickyPosition.top}px)`);
      categoryMenu.style.setProperty('--max-content-width', `calc(100vw - ${categoryMenuHeaderPosition.x}px)`);
      categoryMenu.style.setProperty('--offset-left', `${categoryMenuHeaderPosition.x}px`);
      document.body.classList.add('category-menu-fixed');
    }
  }
});
